/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import VocPage from '@views/VocPage'

const VocPagePopup: React.FC = () => {
  return (
    <div style={{ overflow: 'auto', height: '100%', background: 'none' }}>
      <VocPage/>
    </div>
  )
}

export default observer(VocPagePopup)
